export const appsApiRequestLogRequests = "/apps/api_request_log/requests";
